import { memo } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { PlusOutlined } from "@ant-design/icons";

const Add = ({
  id = "btn-add",
  title,
  icon = <PlusOutlined />,
  type = "primary",
  onClick = () => {},
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const btnTitle = title ? title : t("button.add");

  return (
    <Button
      className={`hover:opacity-70 ${className}`}
      id={id}
      type={type}
      icon={icon}
      onClick={onClick}
      {...props}
    >
      {btnTitle}
    </Button>
  );
};

export default memo(Add);
